module.exports = __webpack_public_path__ + "img/file-image.2e5464a5.svg";